import { render, staticRenderFns } from "./CustomerList079DataTable.vue?vue&type=template&id=6379e7bc&scoped=true"
import script from "./CustomerList079DataTable.vue?vue&type=script&lang=js"
export * from "./CustomerList079DataTable.vue?vue&type=script&lang=js"
import style0 from "./CustomerList079DataTable.vue?vue&type=style&index=0&id=6379e7bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6379e7bc",
  null
  
)

export default component.exports